<template>
  <div>
    <b-alert v-if="isLoading" variant="dark" show>
      <i class="fas fa-ghost"></i>
      {{ message || 'Rendering page' }}&hellip;
    </b-alert>
    <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>
    <div v-if="!isLoading">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['error', 'isLoading', 'message'],
};
</script>
